<template>
  <ApolloMutation
    :mutation="REQUEST_RESET_PASSWORD"
    :variables="{ email: email }"
    @done="$router.push('/auth/reset-password-sent')"
  >
    <template v-slot="{ mutate, loading }">
      <v-card class="text-center" elevation="0">
        <v-card-title class="pl-0">
          <StepHeader>
          {{ $t("password.forgotPassword") }}
          </StepHeader>
        </v-card-title>
        <v-card-text class="mt-9">
          <v-form @submit="mutate" onSubmit="return false;">
            <v-text-field
              v-model="email"
              :disabled="user != null"
              :label="$t('login.email')"
              single-line
              :rules="[() => !!email || $t('forms.thisFieldIsRequired')]"
              tabindex="1"
              dense
              outlined
            />
            <p class="my-8 mb-12">
              {{ $t("password.aLinkToResetYourPasswordWillBeSent") }}
            </p>
            <v-btn
              tabindex="4"
              :disabled="!valid || loading"
              :loading="loading"
              block
              type="submit"
              color="primary"
              >{{ $t("forms.submit") }}</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </ApolloMutation>
</template>
<script>
import StepHeader from "@/components/Reusable/StepHeader.vue";
import { REQUEST_RESET_PASSWORD } from "@/graphql/AuthMutations";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
export default {
  mixins: [hasLoggedInUser],
  components: {
    StepHeader,
  },
  data() {
    return {
      email: "",
      emailErrors: [],
    };
  },
  computed: {
    valid() {
      return this.email != "";
    },
    REQUEST_RESET_PASSWORD() {
      return REQUEST_RESET_PASSWORD;
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.email = newValue.email;
      }
    }
  }
};
</script>